import React, { Component } from 'react';
import axios from 'axios';
import Helmet from 'react-helmet';

const initialState = {
    credentialId: '',
    newCredentialName: '',
    complete: false,
    errorMap: null,
    loading: false
}

class PasskeyChange extends Component {
    state = initialState;

    componentDidMount() {

        // GA計測用データレイヤースクリプトを追加する
        window.addDataLayerScript('jmbauth_passkey_name_change');

        this.setState({
            credentialId: this.props.location.state.credentialId,
            newCredentialName: this.props.location.state.credentialName,
        });
    }

    // パスキー名変更完了画面へ遷移する
    change = async () => {
        let messageList = JSON.parse(sessionStorage.getItem('messageList'));

        // Cookieからl_sidを取得する
        let l_sid = window.getCookieValue('l_sid');

        // アクショントークン格納変数の宣言
        let actionToken = null;

        // SDK呼出(アクションレポート)
        try {
            // アクションのレポート作成
            const actionPromise = window.tsPlatform.drs.triggerActionEvent("account_details_change_passkey_name", { correlationId: l_sid });

            // タイムアウト判定関数
            const timeoutPromise = new Promise((_, reject) => {
                setTimeout(() => {
                    reject(new Error('Action token request timed out'));
                }, process.env.REACT_APP_TRIGGERACTIONEVENT_TIMEOUT); // envに設定されたタイムアウト時間(ミリ秒)を設定
            });

            // タイムアウト時間内にアクショントークンが取得できた場合、アクショントークン変数に設定
            const actionResponse = await Promise.race([actionPromise, timeoutPromise]);
            actionToken = actionResponse ? actionResponse.actionToken : null;
        } catch (e) {
            // タイムアウト時の処理
            if (e.message.includes('timed out')) {
                // エラー文言を、アクショントークン変数に設定
                actionToken = 'jallogin_transmit_api_timeout';
            }
        }

        // 入力値の取得
        const { newCredentialName } = this.state;

        // バリデーションチェック
        if (newCredentialName === '') {
            this.setState({ errorMap: { ERROR: messageList.passkeyChange.M010_errorMessage001, errorId: 'newCredentialName' } });
            // エラーメッセージ表示領域に遷移する
            window.location = "#JS_error";
            return;
        }
        if (this.calcStrWidth(newCredentialName) > 28) {
            this.setState({ errorMap: { ERROR: messageList.passkeyChange.M012_errorMessage003, errorId: 'newCredentialName' } });
            // エラーメッセージ表示領域に遷移する
            window.location = "#JS_error";
            return;
        }

        // FIDO2クレデンシャル名更新要求を行う
        try {
            // ローディング開始
            this.setState({ loading: true });

            // FIDO2クレデンシャル名更新APIを呼出す
            axios({
                method: 'PUT',
                url: process.env.REACT_APP_URL_CO_SC_API_CREDENTIAL_INFO_UPDATE,
                data:
                {
                    credentialId: this.state.credentialId,
                    credentialName: newCredentialName,
                },
                headers: {
                    'accept-language': window.changeLang(sessionStorage.getItem('lang')),
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache'
                }
            })
                .then((response) => {
                    this.setState({
                        complete: true,
                        errorMap: null,
                        loading: false
                    });

                    // GA計測用データレイヤースクリプトを追加する
                    window.addDataLayerScript('jmbauth_passkey_name_change_completion');
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status === 400) {
                            this.setState({
                                errorMap: { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.passkeyChange.M011_errorMessage002 },
                                loading: false,
                                newCredentialName: ''
                            });
                            // エラーメッセージ表示領域に遷移する
                            window.location = "#JS_error";
                        }
                        else if (error.response.status === 401) {
                            this.setState({
                                errorMap: { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.passkeyChange.M011_errorMessage002 },
                                loading: false,
                                newCredentialName: ''
                            });
                            // エラーメッセージ表示領域に遷移する
                            window.location = "#JS_error";
                        }
                        else if (error.response.status === 500) {
                            if (error.response.data.errorCode === 'CO-FS2A04' ) {
                                // CO-FS2A04が返却された場合
                                this.setState({
                                    errorMap: { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.passkeyChange.M011_errorMessage002 },
                                    loading: false,
                                    newCredentialName: ''
                                });
                                // エラーメッセージ表示領域に遷移する
                                window.location = "#JS_error";
                            } else {
                                // エラー画面に遷移し、処理を終了する
                                this.props.history.push({
                                    pathname: `${process.env.REACT_APP_CONTEXT_PATH}/error`
                                });
                            }
                        }
                        else {
                            this.setState({
                                errorMap: { ERROR: messageList.passkeyChange.M011_errorMessage002 },
                                loading: false,
                                newCredentialName: ''
                            });
                            // エラーメッセージ表示領域に遷移する
                            window.location = "#JS_error";
                        }
                    }
                    else {
                        this.setState({
                            errorMap: { ERROR: messageList.passkeyChange.M011_errorMessage002 },
                            loading: false,
                            newCredentialName: ''
                        });
                        // エラーメッセージ表示領域に遷移する
                        window.location = "#JS_error";
                    }
                })
        } catch (error) {
            this.setState({
                errorMap: { ERROR: messageList.passkeyChange.M011_errorMessage002 },
                loading: false,
                newCredentialName: ''
            });
            // エラーメッセージ表示領域に遷移する
            window.location = "#JS_error";
        } finally {
        }
    }

    toPasskey = e => {
        window.location.href = `${process.env.REACT_APP_CONTEXT_PATH}/menu/fido/top?design=` + sessionStorage.getItem('design') + "&lang=" + sessionStorage.getItem('lang');
    }

    handleChange = e => {
        this.setState({ [e.currentTarget.name]: e.currentTarget.value.trim() });
    }

    // Enterキー押下時処理
    handleKeyPress = e => {
        if (e.key === "Enter") {
            e.preventDefault();
            this.change();
        }
    }

    // 文字幅計算
    calcStrWidth(str) {
        let width = 0;

        for (const ch of str) {
            const code = ch.codePointAt(0);
            if (code <= 0x7f) {
                width += 1;
            } else {
                width += 2;
            }
        }

        return width;
    }

    render() {

        // 文言リストを取得する
        let messageList = JSON.parse(sessionStorage.getItem('messageList'));

        // パスキー名変更完了画面表示
        if (this.state.complete) {
            return (
                <section className="content">
                    <Helmet
                        title={messageList.passkeyChangeCompletion.M001_browserTitle} >
                    </Helmet>

                    {/* 画面タイトル表示部 */}
                    <div className="ds-heading ds-heading--lg">
                        <h1 className="ds-heading__title">{messageList.passkeyChangeCompletion.M002_pageTitle}</h1>
                    </div>

                    <div className="contentInner">
                        {/* 操作ボタン表示部 */}
                        <div className="buttonLayout">
                            <div className="buttonWrap buttonWrap--center">
                                {/* .ds-button */}
                                <div className="ds-button ds-button--tertiary ds-button--large">
                                    <button className="ds-button__trigger" type="button" onClick={this.toPasskey}>
                                        <span className="ds-button__label">{messageList.passkeyChangeCompletion.M003_back}</span>
                                    </button>
                                </div>
                                {/* / .ds-button */}
                            </div>
                        </div>
                        {/* / .buttonLayout */}
                    </div>

                </section>
            );
        }

        // パスキー名変更画面表示
        else {
            return (
                <section className="content">
                    <Helmet
                        title={messageList.passkeyChange.M001_browserTitle} >
                    </Helmet>

                    { // Loadingモーダル表示
                        this.state.loading &&
                        <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/assets/img/load.gif`} alt="loading" /></div>
                    }

                    {/* 画面タイトル表示部 */}
                    <div className="ds-heading ds-heading--lg">
                        <h1 className="ds-heading__title">{messageList.passkeyChange.M002_pageTitle}</h1>
                    </div>

                    <div className="contentInner">
                        <p className="ds-text">{messageList.passkeyChange.M003_guideMessage001}<br />{messageList.passkeyChange.M004_guideMessage002}</p>

                        <div id="JS_error">
                            { // エラーメッセージ表示
                                (this.state.errorMap && this.state.errorMap.ERROR) &&
                                <div className="ds-inlineNote ds-inlineNote--attention" role="alert" aria-live="assertive">
                                    <div className="ds-inlineNote__details">
                                        <div className="ds-inlineNote__summary">
                                            <h2 className="ds-inlineNote__heading">
                                                <span className="ds-inlineNote__headingIcon">
                                                    <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.passkeyChange.M005_errorIconText}>
                                                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                                                    </svg>
                                                </span>
                                                <span className="ds-inlineNote__headingLabel">{messageList.passkeyChange.M006_errorBoxTitle}</span>
                                            </h2>
                                        </div>
                                        <div className="ds-inlineNote__content">
                                            <p className="ds-text">{this.state.errorMap.ERROR}</p>
                                        </div>
                                    </div>
                                </div>/* /ds-inlineNote */
                            }
                        </div>

                        <form>
                            <div className="formPanel formPanel--simple">
                                <div className="formWrap">
                                    {/* .ds-textfield */}
                                    <label className="formLabel" htmlFor="LB_input-passkey">
                                        <span className="formLabel__text">{messageList.passkeyChange.M007_passkeyName}</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="LB_input-passkey"
                                        name="newCredentialName"
                                        className={this.state.errorMap && this.state.errorMap.errorId === 'newCredentialName' ? "ds-textfield is-error" : "ds-textfield"}
                                        maxLength="28"
                                        value={this.state.newCredentialName}
                                        onChange={this.handleChange}
                                        onKeyPress={this.handleKeyPress}
                                        aria-invalid={this.state.errorMap && this.state.errorMap.errorId === 'newCredentialName' ? "true" : "false"}
                                        required
                                    />
                                    {/* / .ds-textfield */}
                                </div>
                            </div>

                            {/* 操作ボタン表示部 */}
                            <div className="buttonLayout">
                                <div className="buttonWrap buttonWrap--center">
                                    {/* .ds-button */}
                                    <div className="ds-button ds-button--primary ds-button--large">
                                        <button className="ds-button__trigger" type="button" formNoValidate onClick={this.change}>
                                            <span className="ds-button__label">{messageList.passkeyChange.M008_change}</span>
                                        </button>
                                    </div>
                                    {/* / .ds-button */}
                                </div>
                                <div className="buttonWrap buttonWrap--left">
                                    {/* .ds-button */}
                                    <div className="ds-button ds-button--tertiary ds-button--large">
                                        <button className="ds-button__trigger" type="button" onClick={this.toPasskey}>
                                            <span className="ds-button__label">{messageList.passkeyChange.M009_back}</span>
                                        </button>
                                    </div>
                                    {/* / .ds-button */}
                                </div>
                            </div>
                            {/* / .buttonLayout */}
                        </form>
                    </div>

                </section>
            );
        }

    }
}

export default PasskeyChange
